/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import qs from 'qs';
// import { history } from 'react-router-dom';
import { detect } from 'detect-browser';
import Storage from './Storage';
import { getScreenResolution } from '../utils/utils';
import { API_CONSTANTS } from '../constants/api-constant';
import moment from 'moment';
import ModalService from './ModalService';
import swal from 'sweetalert';

const { TOKEN_REFRESH_IN_ADVANCE = 2 } = process.env;
const { LOGIN_DATA } = API_CONSTANTS;

let isForcetoLogin = false;

function redirectToLogin() {
  Storage.clearLocalStorage();
  Storage.clearSessionStorage();
  window.location.href = '/';
}

function refreshRequestToken(refreshToken) {
  const refreshTokenBody = {
    refresh_token: refreshToken,
    grant_type: 'refresh_token',
  };
  return request('POST', `${LOGIN_DATA}`, null, refreshTokenBody, {
    'content-type': 'application/x-www-form-urlencoded',
    app: 'agrocel',
  })
    .then((data) => {
      const response = data.data;

      const obj = {
        accessToken: response.accessToken,
        accessTokenExpiresAt: response.accessTokenExpiresAt,
        refreshToken: response.refreshToken,
        refreshTokenExpiresAt: response.refreshTokenExpiresAt,
      };

      const userDetail = response.user;
      Storage.setTokenDetail(obj);
      Storage.setUserDetail(userDetail);
      return Promise.resolve(data);
      // store token to localstorage and send seconde request
    })
    .catch((e) => {
      // window.history.replaceState(null, null, '/#/login');
      const err =
        e.response &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      const errorName = err ? err.name : '';
      if (errorName === 'invalid_grant') {
        redirectToLogin();
        return Promise.reject(e);
      }
      return Promise.reject(e);
      // remove tokens and redirect to logout
    });
}

/**
 * request interceptors
 * @param {String} method GET,PUT,POST,DELETE
 * @param {String} url req url
 * @param {Object} params query parameters
 * @param {Object} body req body
 * @param {Object} headers req headers
 */
export const request = (
  method,
  url,
  params,
  body = {},
  headers = {},
  token = '',
) => {
  if (isForcetoLogin === true) return {};
  token = Storage.getTokenDetail() ? Storage.getTokenDetail() : token;
  // if (url.indexOf('get-dealer-count-hierarchy-wise') > 0) {
  //   token.refreshTokenExpiresAt = '2022-11-10T13:31:03.114Z';
  // }
  const browser = detect();
  const browserName = browser.name;
  const { version } = browser;

  headers = headers || {};
  params = params || {};
  body = body || {};

  headers.devicetype = 'web';
  headers.web_version = version;
  headers.browser_name = browserName;
  headers.app = 'agrocel';
  headers.resolution = getScreenResolution();

  if (!headers['content-type']) {
    headers['content-type'] = 'application/json';
  }

  if (
    !(
      url.includes('auth/login') ||
      url.includes('forgot-password') ||
      url.includes('crm-points/about')
    )
  ) {
    if (token && typeof token === 'object' && Object.keys(token).length > 0) {
      headers.Authorization = `Bearer ${token.accessToken}`;
    } else if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  } else if (url.includes('login')) {
    headers.Authorization = `Basic ${process.env.REACT_APP_API_KEY}`;
  }
  if (window.location.href.includes('event-registration')) {
    headers.Authorization = `Bearer ${token}`;
  }

  const options = {
    method,
    headers,
    params,
    url,
  };
  if (
    (method === 'POST' || method === 'PUT') &&
    headers['content-type'] === 'application/x-www-form-urlencoded'
  ) {
    options.data = qs.stringify(body);
  } 
  else if (
    (method === 'POST' || method === 'PUT') &&
    headers['content-type'] === 'multipart/form-data'
  ) {
    headers['content-type'] = 'multipart/form-data';

    // prepate multipart formdata body
    // const formData = new FormData();
    // const keys = Object.keys(body);

    // for (let i = 0; i < keys.length; i++) {
    //   if (
    //     body[keys[i]] &&
    //     typeof body[keys[i]] === 'object' &&
    //     Object.keys(body[keys[i]]).length > 0
    //   ) {
    //     for (const key of Object.keys(body[keys[i]])) {
    //       formData.append(keys[i], body[keys[i]][key]);
    //     }
    //   } else {
    //     formData.append(keys[i], body[keys[i]]);
    //   }
    // }
    // options.data = formData;
    options.data = body;
  } else if (method === 'POST' || method === 'PUT') {
    options.data = body;
  }

  return axios(options)
    .then((data) => {
      // REFRESH TOKEN TWO DAYS AGO
      if (token && typeof token === 'object' && Object.keys(token).length > 0) {
        let days = moment(token.accessTokenExpiresAt).diff(moment(), 'days');
        if (days <= TOKEN_REFRESH_IN_ADVANCE && days >= 0) {
          refreshRequestToken(token.refreshToken);
        }
      }
      return Promise.resolve(data);
    })
    .catch((e) => {
      console.log('request error', e);
      const err =
        e.response &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error.length > 0 &&
        e.response.data.error[0]
          ? e.response.data.error[0]
          : null;
      let errorName = err ? err.name : '';
      errorName = !errorName ? err.message : errorName;
      console.log('errorName', errorName);
      if (window.location.href.includes('reset-password') && (errorName === "Your forgot password link is expired. Please get the new link" || errorName === "Token Expired!" )) {
            swal({
                className: 'approveAlert',
                text: `Your forgot password link is expired. Please get the new link`,
                // icon: "error",
            }).then(function () {
                window.location.href = `#/user/forgot-password`;
            })
      } else {
        ModalService.openAlert('', errorName, 'error');
      }

      const preserveRequest = options;
      if (
        url.includes('login') &&
        window.location.href.indexOf('login') <= -1
      ) {
        isForcetoLogin = true;
        Storage.clearLocalStorage();
        Storage.clearSessionStorage();
        window.location.href = '/';
      } else if (errorName === 'invalid_token') {
        if (!token.refreshToken) {
          redirectToLogin();
          return Promise.reject(e);
        }
        return refreshRequestToken(token.refreshToken)
          .then((data) => {
            const accessToken = data.data.accessToken;
            preserveRequest.headers.Authorization = `Bearer ${accessToken}`;
            console.log('new access token retrived successfully');
            console.log('new request created');
            return axios(preserveRequest);
          })
          .then((data) => {
            return Promise.resolve(data);
          })
          .catch((e) => {
            return Promise.reject(e);
          });
      }

      if (errorName !== 'invalid_token') {
        return Promise.reject(e);
      }
    });
};

/**
 * new request interceptors
 * @param {String} method GET,PUT,POST,DELETE
 * @param {String} url req url
 * @param {Object} params query parameters
 * @param {Object} body req body
 * @param {Object} headers req headers
 */
export const newRequest = async (
  method,
  url,
  params,
  body = {},
  headers = {},
) => {
  const { data = {} } = await request(method, url, params, body, headers);
  return data;
};
